import { useTranslation } from "react-i18next";
import { InlineLoader } from "../../../components/loader/CharacterizationLoader";
import CampaignWeekProgress from "./CampaignWeekProgress";
import CampaignAlertsProgressBar from "./CampaignAlertsProgressBar";

const CampaignProgressSection = ({ progress, isLoading, campaignStop }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <section className="campaign-progress-section">
        <h2 className="campaign-progress-section__title">
          {t("campaign.progressTitle")}
        </h2>
        <div className="campaign-progress-section__loader">
          <InlineLoader height="160px" />
        </div>
      </section>
    );
  }

  if (!progress) {
    return null;
  }

  return (
    <section className="campaign-progress-section">
      <h2 className="campaign-progress-section__title">
        {t("campaign.progressTitle")}
      </h2>
      <div className="campaign-progress-section__grid">
        <CampaignWeekProgress weekDays={progress.week} />
        <CampaignAlertsProgressBar
          treated={progress.alerts?.treated}
          total={progress.alerts?.total}
          percent={progress.alerts?.percent}
          campaignStop={campaignStop}
        />
      </div>
    </section>
  );
};

export default CampaignProgressSection;
